import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import TeeTimesWidgetComponent from './js/tee-times-widget.component';
import TeeTimesWidgetList from './js/tee-times-widget-list';

ComponentsFactory.getInstance().define('tee-times-widget', TeeTimesWidgetComponent);

export {
    TeeTimesWidgetList,
};
